export const GROWTH = 0.02;
export const RETURN = 0.03;

const latest = (t, key) => {
  const pts = (t.history?.asking || []).filter((p) => p[key]);
  return pts.length ? pts[pts.length - 1][key] : null;
};

export const defaults = (t) => {
  const p = t.property;
  if (!p?.typical_price) return null;
  const sqm = latest(t, "sale_sqm");
  const size = sqm ? Math.round(p.typical_price / sqm) : 80;
  const rsqm = latest(t, "rent_sqm");
  const rent = rsqm ? rsqm * size : t.rent_1bed ? ((t.rent_1bed.low + t.rent_1bed.high) / 2) * (size / 50) : null;
  return rent ? { price: p.typical_price, rent: Math.round(rent), size } : null;
};

// Rent vs buy using the town's buying and running cost rates; `mine` overrides price/rent with the visitor's numbers.
export const rentVsBuy = (t, mine = {}) => {
  const d = defaults(t);
  if (!d) return null;
  const p = t.property;
  const price = mine.price > 0 ? mine.price : d.price;
  const rent = mine.rent > 0 ? mine.rent : d.rent;
  const upfront = price * p.closing_pct / 100 + p.closing_fixed;
  const yearly = price * p.yearly_pct / 100 + p.yearly_fixed;
  const totals = (n) => {
    let rentT = 0, own = 0;
    for (let y = 0; y < n; y += 1) { rentT += rent * 12 * (1 + GROWTH) ** y; own += yearly * (1 + GROWTH) ** y; }
    const forgone = (price + upfront) * ((1 + RETURN) ** n - 1);
    return { rent: rentT, buy: upfront + own + forgone - (price * (1 + GROWTH) ** n - price) };
  };
  let breakEven = null;
  for (let n = 1; n <= 40; n += 1) { const x = totals(n); if (x.buy < x.rent) { breakEven = n; break; } }
  const years = mine.years > 0 ? Math.min(60, mine.years) : null;
  return { size: d.size, price, rentMonth: rent, ownMonth: yearly / 12, upfront, breakEven, y5: totals(5), y10: totals(10), y20: totals(20), mine: years ? { years, ...totals(years) } : null };
};

export const beText = (r) => (r.breakEven ? `${r.breakEven} year${r.breakEven === 1 ? "" : "s"}` : "40+ years");
